import {getRegionCodeForCountryCode, parsePhoneNumber} from 'awesome-phonenumber'

export const isValidMobilePhone = (value, model) => {
  const regionCode = getRegionCodeForCountryCode(model?.PhonePrefix || '30')
  const phone = parsePhoneNumber(value, {regionCode: regionCode || 'GR'})
  return phone.valid && phone.typeIsMobile
}
